import { c as _c } from "react/compiler-runtime";
import { ExtendedWaveParticipationRequirement } from "./CreateWaveDropsTypes.constants";
export default function CreateWaveDropsType(t0) {
  const $ = _c(20);
  const {
    isChecked,
    type,
    onRequiredTypeChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ExtendedWaveParticipationRequirement.NONE]: "None",
      [ExtendedWaveParticipationRequirement.IMAGE]: "Image",
      [ExtendedWaveParticipationRequirement.AUDIO]: "Audio",
      [ExtendedWaveParticipationRequirement.VIDEO]: "Video"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  const buttonClasses = isChecked ? "tw-border-primary-400 tw-bg-primary-500/5 tw-ring-primary-500/30" : "tw-border-white/5 tw-bg-iron-900 tw-ring-white/5 hover:tw-border-white/10 hover:tw-bg-iron-800 hover:tw-ring-white/10";
  const labelClasses = isChecked ? "tw-text-white" : "tw-text-iron-300 group-hover:tw-text-white";
  const t2 = `${buttonClasses} tw-group tw-relative tw-flex tw-min-h-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-xl tw-border tw-border-solid tw-px-3 tw-py-3 tw-shadow-inner tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t3;
  if ($[1] !== onRequiredTypeChange || $[2] !== type) {
    t3 = () => onRequiredTypeChange(type);
    $[1] = onRequiredTypeChange;
    $[2] = type;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isChecked || $[5] !== t3) {
    t4 = <input checked={isChecked} onChange={t3} type="radio" name="required-media-type" className="tw-peer tw-sr-only" />;
    $[4] = isChecked;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `tw-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition tw-duration-300 tw-ease-out peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-primary-500 peer-focus-visible:tw-ring-offset-2 peer-focus-visible:tw-ring-offset-iron-950 ${isChecked ? "tw-border-primary-400 tw-bg-primary-500/10" : "tw-border-iron-600 tw-bg-transparent group-hover:tw-border-iron-500"}`;
  const t6 = `tw-h-2 tw-w-2 tw-rounded-full tw-bg-primary-400 tw-transition tw-duration-200 ${isChecked ? "tw-scale-100" : "tw-scale-0"}`;
  let t7;
  if ($[7] !== t6) {
    t7 = <span className={t6} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <span aria-hidden="true" className={t5}>{t7}</span>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `${labelClasses} tw-text-sm tw-font-semibold`;
  const t10 = LABELS[type];
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className="tw-flex tw-min-w-0 tw-flex-col"><span className={t9}>{t10}</span></div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t2 || $[17] !== t4 || $[18] !== t8) {
    t12 = <label className={t2}>{t4}{t8}{t11}</label>;
    $[15] = t11;
    $[16] = t2;
    $[17] = t4;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}